import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/authentication/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
	selector: 'app-header',
	templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements OnInit {

	utilisateurName: string = "";

	constructor(
		private http: HttpClient,
		private authService: AuthService) {

	}

	ngOnInit() {
		let utilisateur = JSON.parse(localStorage.getItem('gapUtilisateur'));
		if (!utilisateur || !utilisateur.Nom) {
			let session = JSON.parse(localStorage.getItem('gapSession'));
			if (session != null) {
				this.http.get<any>('/api/Utilisateur/CleUtilisateur')
					.subscribe(response => {
						if (response.Cle > 0) {
							this.http.get<any>('/api/Utilisateur/Signaletique/' + response.Cle)
								.subscribe(response => {
									if (response.Nom == null || response.Prenom == null) {
										this.utilisateurName = response.Login;
									} else {
										this.utilisateurName = response.Nom + " " + response.Prenom;
									}
								});
						};
					});
			};
		} else {
			this.utilisateurName = utilisateur.Nom + " " + utilisateur.Prenom;
		}
	}


}
